<ng-container *ngIf="action$ | async as action">
  <div [pTooltip]="action.tooltip || action.description" tooltipPosition="top" style="display: inline-block;">
  <p-button
    [icon]="'pi ' + (action.icon ? 'pi-' + action.icon : 'pi-hidden')"
    [ngClass]="action.name + ' hide-label-responsive'"
    [label]="action.description"
    ntapDebounceClick
    (onClick)="executeAction($event)"
    [disabled]="(isDisabled$ | async) ?? true"
    tooltipPosition="left"
  ></p-button>
  </div>
</ng-container>
